import React from 'react';
import Accordion from '../../accordion';
import RecommendedProductHeader from './recommended-product-header';
import RecommendedProductContent from './recommended-product-content';

const RecommendedProduct = (props) => {
  const { productData, authorableContent, cidn } = props;
  const headerComponent = <RecommendedProductHeader cidn={cidn} productData={productData} />;
  return (
    <li className="recommended-product list-group-item">
      <Accordion
        headerComponent={headerComponent}
        onLoadcollapse
        mainColumnClass="pr-0 pr-sm-2"
      >
        <RecommendedProductContent
          productData={productData}
          authorableContent={authorableContent}
        />
      </Accordion>
    </li>
  );
};

export default RecommendedProduct;
